module.exports = __webpack_public_path__ + "resources/img/img_tcc_spec_m.5fefa4efef0578f3d68e5c3eb6865c19.jpg";